// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.c7d0EkDeVohrgiPouQHa {
  font-family: var(--body-font-family);
  font-size: 0.875rem;
  line-height: 1.5rem;
  text-decoration: none;
  letter-spacing: 0;
  cursor: pointer;
  transition: all 0.3s ease-out;
  display: inline-flex;
  align-items: center;
}

.bsSMqYabDOglyesMUYyM {
  display: flex;
}

.Ancdhi9T7g5ha7qGYXzB:hover {
  -webkit-text-decoration-line: underline;
          text-decoration-line: underline
}

.Ancdhi9T7g5ha7qGYXzB:hover p,
  .Ancdhi9T7g5ha7qGYXzB:hover div,
  .Ancdhi9T7g5ha7qGYXzB:hover h1,
  .Ancdhi9T7g5ha7qGYXzB:hover h2,
  .Ancdhi9T7g5ha7qGYXzB:hover h3,
  .Ancdhi9T7g5ha7qGYXzB:hover h4 {
    -webkit-text-decoration-line: underline;
            text-decoration-line: underline;
  }

.IEl0lggnginyZA8NUdST,
.IEl0lggnginyZA8NUdST:focus,
.IEl0lggnginyZA8NUdST:hover,
.IEl0lggnginyZA8NUdST:active {
  color: var(--quaternary-link-color);
}

.nlvT3vUPTXrFmP4LWCsA,
.nlvT3vUPTXrFmP4LWCsA:focus,
.nlvT3vUPTXrFmP4LWCsA:hover,
.nlvT3vUPTXrFmP4LWCsA:active {
  color: var(--teritiary-link-color);
}

.hzP7j1sUWzX0iB1c5Qsw,
.hzP7j1sUWzX0iB1c5Qsw:focus,
.hzP7j1sUWzX0iB1c5Qsw:hover,
.hzP7j1sUWzX0iB1c5Qsw:active {
  color: var(--primary-link-color);
}

.tiYlAGiE1oia7jC2ywx6,
.tiYlAGiE1oia7jC2ywx6:focus,
.tiYlAGiE1oia7jC2ywx6:hover,
.tiYlAGiE1oia7jC2ywx6:active {
  color: var(--secondary-link-color);
}

.Y4yUXQTMGl_FkNYIJep5,
.Y4yUXQTMGl_FkNYIJep5:focus,
.Y4yUXQTMGl_FkNYIJep5:hover,
.Y4yUXQTMGl_FkNYIJep5:active {
  color: var(--midnight-purple);
}

.neDlbjGAb46Lzq7VjHCj,
.neDlbjGAb46Lzq7VjHCj:focus,
.neDlbjGAb46Lzq7VjHCj:hover,
.neDlbjGAb46Lzq7VjHCj:active {
  color: var(--grey-300);
}

.J7xJ7MnMoviylQTycH5h {
  text-transform: uppercase;
}

.CztsajuHeGcW8FzFu3fm {
  text-transform: lowercase;
}

.Oj2rBai5Vm5NedmpVpAY {
  text-transform: capitalize;
}

.BfFn2icoa0LAySgjH5Uy {
  cursor: default;
  -webkit-text-decoration-line: none;
          text-decoration-line: none;
}

.BfFn2icoa0LAySgjH5Uy:hover {
  -webkit-text-decoration-line: none;
          text-decoration-line: none;
}

.LQYjoXozSbvTK6k6eUbJ {
  white-space: unset;
  -webkit-hyphens: auto;
          hyphens: auto;
  word-break: break-word;
}
`, "",{"version":3,"sources":["webpack://./src/components/Link/Link.module.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,mBAAe;EACf,mBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uCAA+B;UAA/B;AAUF;;AARE;;;;;;IAME,uCAA+B;YAA/B,+BAA+B;EACjC;;AAGF;;;;EAIE,mCAAmC;AACrC;;AAEA;;;;EAIE,kCAAkC;AACpC;;AAEA;;;;EAIE,gCAAgC;AAClC;;AAEA;;;;EAIE,kCAAkC;AACpC;;AAEA;;;;EAIE,6BAA6B;AAC/B;;AAEA;;;;EAIE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,kCAA0B;UAA1B,0BAA0B;AAC5B;;AAEA;EACE,kCAA0B;UAA1B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,qBAAa;UAAb,aAAa;EACb,sBAAsB;AACxB","sourcesContent":[".link {\n  font-family: var(--body-font-family);\n  font-size: 14px;\n  line-height: 24px;\n  text-decoration: none;\n  letter-spacing: 0;\n  cursor: pointer;\n  transition: all 0.3s ease-out;\n  display: inline-flex;\n  align-items: center;\n}\n\n.block {\n  display: flex;\n}\n\n.hover:hover {\n  text-decoration-line: underline;\n\n  & p,\n  & div,\n  & h1,\n  & h2,\n  & h3,\n  & h4 {\n    text-decoration-line: underline;\n  }\n}\n\n.quaternary,\n.quaternary:focus,\n.quaternary:hover,\n.quaternary:active {\n  color: var(--quaternary-link-color);\n}\n\n.tertiary,\n.tertiary:focus,\n.tertiary:hover,\n.tertiary:active {\n  color: var(--teritiary-link-color);\n}\n\n.primary,\n.primary:focus,\n.primary:hover,\n.primary:active {\n  color: var(--primary-link-color);\n}\n\n.secondary,\n.secondary:focus,\n.secondary:hover,\n.secondary:active {\n  color: var(--secondary-link-color);\n}\n\n.breadcrumbs,\n.breadcrumbs:focus,\n.breadcrumbs:hover,\n.breadcrumbs:active {\n  color: var(--midnight-purple);\n}\n\n.lastBreadcrumb,\n.lastBreadcrumb:focus,\n.lastBreadcrumb:hover,\n.lastBreadcrumb:active {\n  color: var(--grey-300);\n}\n\n.uppercase {\n  text-transform: uppercase;\n}\n\n.lowercase {\n  text-transform: lowercase;\n}\n\n.capitalize {\n  text-transform: capitalize;\n}\n\n.span {\n  cursor: default;\n  text-decoration-line: none;\n}\n\n.span:hover {\n  text-decoration-line: none;\n}\n\n.noWrap {\n  white-space: unset;\n  hyphens: auto;\n  word-break: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": `c7d0EkDeVohrgiPouQHa`,
	"block": `bsSMqYabDOglyesMUYyM`,
	"hover": `Ancdhi9T7g5ha7qGYXzB`,
	"quaternary": `IEl0lggnginyZA8NUdST`,
	"tertiary": `nlvT3vUPTXrFmP4LWCsA`,
	"primary": `hzP7j1sUWzX0iB1c5Qsw`,
	"secondary": `tiYlAGiE1oia7jC2ywx6`,
	"breadcrumbs": `Y4yUXQTMGl_FkNYIJep5`,
	"lastBreadcrumb": `neDlbjGAb46Lzq7VjHCj`,
	"uppercase": `J7xJ7MnMoviylQTycH5h`,
	"lowercase": `CztsajuHeGcW8FzFu3fm`,
	"capitalize": `Oj2rBai5Vm5NedmpVpAY`,
	"span": `BfFn2icoa0LAySgjH5Uy`,
	"noWrap": `LQYjoXozSbvTK6k6eUbJ`
};
export default ___CSS_LOADER_EXPORT___;
